<template>
  <div class="container my-5">
    <h1>Environment Variables Test</h1>
    <div class="card mt-4">
      <div class="card-body">
        <h5 class="card-title">Runtime Config Values</h5>
        <table class="table table-bordered">
          <tbody>
            <tr>
              <th>API URL</th>
              <td>{{ config.public.apiUrl || '(empty)' }}</td>
            </tr>
            <tr>
              <th>Cognito Region</th>
              <td>{{ config.public.cognitoRegion || '(empty)' }}</td>
            </tr>
            <tr>
              <th>Cognito User Pool ID</th>
              <td>{{ config.public.cognitoUserPoolId || '(empty)' }}</td>
            </tr>
            <tr>
              <th>Cognito Client ID</th>
              <td>{{ config.public.cognitoUserPoolWebClientId || '(empty)' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup>
const config = useRuntimeConfig()
</script>
